import { issuesApi } from "api/issuesApi";
import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { TASKS_STATUSES } from "consts/tasks";

const useIssues = (filter: string) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.ISSUES(filter),
    queryFn: () => issuesApi.fetch(filter),
  });

  return { isLoading, issues: data?.data ?? [], refresh: () => refetch() };
};

const ALL_ISSUES_FILTER = `status in (${TASKS_STATUSES.TODO},${TASKS_STATUSES.INPROGRESS},${TASKS_STATUSES.DONE})`;
export const ALL_ISSUES_QUERY = QUERIES_KEYS.ISSUES(ALL_ISSUES_FILTER);
export const useAllIssues = () => useIssues(ALL_ISSUES_FILTER);

const ARCHIVED_ISSUES_FILTER = `status in (${TASKS_STATUSES.ARCHIVED})`;
export const ARCHIVED_ISSUES_QUERY = QUERIES_KEYS.ISSUES(ARCHIVED_ISSUES_FILTER);
export const useArchivedIssues = () => useIssues(ARCHIVED_ISSUES_FILTER);
